import { useTranslation } from '@/lib/i18n/i18n.client';
import { useApi } from '@/hooks/useApi';

import { sendGAEvent } from '@/components/integrations/trackingScripts';

import { apiEndpoints } from '@/constant/urls';
import { Text } from '@/decodo/components/atoms/Text';

import { ContactSalesForm, ContactSalesFormSchema } from './ContactSalesForm';

type FormPageProps = {
  onSuccess: () => void;
  onError: () => void;
};

export function FormPage({ onSuccess, onError }: FormPageProps) {
  const { loading, makeApiCall } = useApi({
    url: apiEndpoints.contactSales,
    method: 'POST',
  });

  const { texts, lang } = useTranslation();

  async function handleSubmit(data: ContactSalesFormSchema) {
    const response = await makeApiCall({
      body: {
        ...data,
        companyPhone: data.companyPhone
          ? data.countryCode + data.companyPhone
          : data.companyPhone,
        languageCode: lang === 'zh-cn' ? 'CN' : '', // empty string required
      } satisfies ContactSalesFormSchema,
    });

    if (response?.data) {
      onSuccess();
      sendGAEvent({
        event: 'ContactSalesForm_submitted',
      });
    } else {
      onError();
    }
  }

  return (
    <div className='flex flex-col gap-y-8 md:gap-y-10'>
      <Text className='text-h3 font-serif'>
        {texts.contact_sales.form.title}
      </Text>
      <ContactSalesForm onSubmit={handleSubmit} loading={loading} />
    </div>
  );
}
